module.exports = __webpack_public_path__ + "ba6d6a9298fc41454a8aacc62206f795.svg";